type Translate = (key: string, fallback: string) => string;

// The API sends volatility as a 1-6 rating; the bare number tells a player nothing.
const VOLATILITY_PHRASES: Record<number, [key: string, fallback: string]> = {
  1: ["game.stats.volatility.low", "Low volatility"],
  2: ["game.stats.volatility.lowmedium", "Low-medium volatility"],
  3: ["game.stats.volatility.medium", "Medium volatility"],
  4: ["game.stats.volatility.mediumhigh", "Medium-high volatility"],
  5: ["game.stats.volatility.high", "High volatility"],
  6: ["game.stats.volatility.superhigh", "Super-high volatility"],
};

const formatVolatility = (volatility: number | undefined, t: Translate) => {
  if (volatility === undefined) return undefined;
  const phrase = VOLATILITY_PHRASES[volatility];
  return phrase && t(...phrase);
};

export default formatVolatility;
